const TIANDITU_TK = '580b1dded95f7707c0301a5b808b2d26';
const TIANDITU_SCRIPT = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_TK}`;

let loadingPromise = null;

function isTiandituReady() {
  return typeof window !== 'undefined' && window.T && typeof window.T.Map === 'function';
}

function waitForTiandituReady(timeoutMs = 8000) {
  return new Promise((resolve, reject) => {
    if (isTiandituReady()) {
      resolve(window.T);
      return;
    }
    const start = Date.now();
    const timer = setInterval(() => {
      if (isTiandituReady()) {
        clearInterval(timer);
        resolve(window.T);
        return;
      }
      if (Date.now() - start >= timeoutMs) {
        clearInterval(timer);
        reject(new Error('天地图 API 未就绪'));
      }
    }, 50);
  });
}

/**
 * 按需加载天地图 JS API 4.0
 * @returns {Promise<typeof window.T>}
 */
export function loadTianditu() {
  if (isTiandituReady()) {
    return Promise.resolve(window.T);
  }
  if (loadingPromise) {
    return loadingPromise;
  }
  loadingPromise = new Promise((resolve, reject) => {
    let settled = false;
    const finish = (err, T) => {
      if (settled) return;
      settled = true;
      if (err) {
        loadingPromise = null;
        reject(err);
        return;
      }
      resolve(T);
    };

    const bindExisting = (scriptEl) => {
      if (scriptEl.getAttribute('data-loaded') === '1' || isTiandituReady()) {
        waitForTiandituReady()
          .then((T) => finish(null, T))
          .catch((e) => finish(e));
        return;
      }
      scriptEl.addEventListener('load', () => {
        scriptEl.setAttribute('data-loaded', '1');
        waitForTiandituReady()
          .then((T) => finish(null, T))
          .catch((e) => finish(e));
      });
      scriptEl.addEventListener('error', () => {
        finish(new Error('天地图脚本加载失败'));
      });
      waitForTiandituReady(10000)
        .then((T) => {
          scriptEl.setAttribute('data-loaded', '1');
          finish(null, T);
        })
        .catch((e) => finish(e));
    };

    const exist = document.querySelector(`script[src="${TIANDITU_SCRIPT}"]`);
    if (exist) {
      bindExisting(exist);
      return;
    }
    const script = document.createElement('script');
    script.src = TIANDITU_SCRIPT;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      script.setAttribute('data-loaded', '1');
      waitForTiandituReady()
        .then((T) => finish(null, T))
        .catch((e) => finish(e));
    };
    script.onerror = () => {
      try {
        script.remove();
      } catch (e) {
        // ignore
      }
      finish(new Error('天地图脚本加载失败'));
    };
    document.head.appendChild(script);
  });
  return loadingPromise;
}

/**
 * 地理编码：地址 → 经纬度（WGS84）
 */
export async function geocodeAddress(keyword) {
  const key = String(keyword || '').trim();
  if (!key) return null;
  const ds = encodeURIComponent(JSON.stringify({ keyWord: key }));
  const url = `https://api.tianditu.gov.cn/geocoder?ds=${ds}&tk=${TIANDITU_TK}`;
  const res = await fetch(url);
  if (!res.ok) return null;
  const data = await res.json();
  if (String(data?.status) !== '0') return null;
  const lon = Number(data?.location?.lon);
  const lat = Number(data?.location?.lat);
  if (Number.isNaN(lon) || Number.isNaN(lat) || (lon === 0 && lat === 0)) return null;
  return { lng: lon, lat, address: key };
}

/**
 * 逆地理编码：经纬度（WGS84）→ 地址
 */
export async function reverseGeocodeLngLat(lng, lat) {
  const lon = Number(lng);
  const la = Number(lat);
  if (Number.isNaN(lon) || Number.isNaN(la) || (lon === 0 && la === 0)) {
    return '';
  }
  const postStr = encodeURIComponent(JSON.stringify({ lon, lat: la, ver: 1 }));
  const url = `https://api.tianditu.gov.cn/geocoder?postStr=${postStr}&type=geocode&tk=${TIANDITU_TK}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return '';
    const data = await res.json();
    if (String(data?.status) !== '0') return '';
    return String(
      data?.result?.formatted_address ||
      data?.result?.addressComponent?.address ||
      ''
    ).trim();
  } catch (e) {
    return '';
  }
}

export { TIANDITU_TK };
